import { lazy } from 'react';

export default {
  exact: false,
  name: 'Card-less-atm',
  protected: true,
  path: '/card-less-atm',
  component: lazy(() =>
    import('containers/GatewayCashout/cardLessAtm'),
  ),
};
